<div>
    <app-aluno-portal></app-aluno-portal>
</div>

<div *ngIf="isAluno">
    <mat-card class="div-minhas-aulas">
        <p class="titulo-minhas-aulas">
            Documentos
        </p>
    </mat-card>
</div>

<div class="body">
    <mat-card class="mat-elevation-z8 noshadow card-principal" *ngIf="!error;else errorTemplate">
        <mat-card-title></mat-card-title>
        <mat-card-content>
            <div class="loading-shade" *ngIf="isLoadingResults">
                <mat-spinner></mat-spinner>
            </div>
            <div class="content" *ngIf="!isLoadingResults">
                <form [formGroup]="form">
                    <div *ngIf="!isAluno" class="flex-end align-center">
                        <div>
                            <button mat-button (click)="gerarDeclaracao()" type="button" color="primary">Gerar
                                Declaração de Pendência &nbsp;<mat-icon>note_add</mat-icon></button>
                            <button mat-button (click)="pendencia.click()" type="button" color="primary">Upload
                                Declaração de Pendência &nbsp;<mat-icon>cloud_upload</mat-icon></button>
                            <button mat-button (click)="downloadDeclaracao()" type="button"
                                [disabled]="declaracaoPendenciaDocumental" color="primary">Download Declaração de
                                Pendência &nbsp;<mat-icon>arrow_downward</mat-icon></button>
                            <button mat-button (click)="visualizarDeclaracao()" type="button"
                                [disabled]="declaracaoPendenciaDocumental" color="primary">Visualizar Declaração de
                                Pendência &nbsp;<mat-icon>aspect_ratio</mat-icon></button>
                        </div>
                    </div>

                    <mat-chip-list *ngIf="documentosPendentes.length > 0">
                        <mat-chip class="bg-red">Documentos pendentes </mat-chip>
                    </mat-chip-list>
                    <ul *ngIf="documentosPendentes.length > 0">
                        <li *ngFor="let doc of documentosPendentes">{{ labelPendente(doc) }}</li>
                    </ul>
                    <div class="flex form-registro">
                        <mat-form-field>
                            <mat-label>Tipo de anexo</mat-label>
                            <mat-select formControlName="tipoAnexo">
                                <mat-option *ngFor="let anexo of documentosExibir" [value]="anexo.value">
                                    {{ anexo.label }}
                                </mat-option>
                            </mat-select>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>
                        <div class="flex align-center">
                            <button mat-button type="button" (click)="fileUp.click()" color="primary">
                                Documento &nbsp;
                                <mat-icon>cloud_upload</mat-icon>
                            </button>
                        </div>
                    </div>

                    <div *ngIf="!isAluno" class="flex form-registro">
                        <mat-form-field>
                            <mat-label>Pendência documental</mat-label>
                            <mat-select [formControl]="inconsistentes" multiple>
                                <mat-option *ngFor="let docs of documentosInconsistenteAll" [value]="docs.value">
                                    {{ docs.label }}
                                </mat-option>
                            </mat-select>
                            <mat-error>Informação necessária</mat-error>
                        </mat-form-field>
                        <div class="flex align-center">
                            <button mat-button type="button" (click)="salvarPendencia()" color="primary">
                                Salvar pendência &nbsp;
                            </button>
                        </div>
                    </div>

                    <div class="flex flex-fill">
                        <div class="loading-shade" *ngIf="isLoadingResults">
                            <mat-spinner></mat-spinner>
                        </div>
                        <div class="table">
                            <table mat-table [dataSource]="dataSource" [hidden]="isLoadingResults">
                                <ng-container matColumnDef="tipoAnexo">
                                    <th mat-header-cell *matHeaderCellDef> Tipo do Documento </th>
                                    <td mat-cell *matCellDef="let element"
                                        [ngStyle]="element?.isRecusado ? { 'text-decoration': 'line-through' } : '' ">
                                        {{labelPendente(element.tipoAnexo)}} </td>
                                </ng-container>

                                <ng-container matColumnDef="dataAnexo">
                                    <th mat-header-cell *matHeaderCellDef> Data do Documento </th>
                                    <td mat-cell *matCellDef="let element"> {{element.dataAnexo ? (element.dataAnexo |
                                        datePtBr) : '-'}} </td>
                                </ng-container>

                                <ng-container matColumnDef="options">
                                    <th mat-header-cell *matHeaderCellDef class="sm-column"> </th>
                                    <td mat-cell *matCellDef="let element; let i = index">
                                        <div class="btn-options">
                                            <button *ngIf="element?.isRecusado"
                                                (click)="opemMsg(element?.mensagem, element?.tipoRecusa)" type="button"
                                                class="yellow" mat-icon-button matTooltip="Reportado">
                                                <mat-icon>report_problem</mat-icon>
                                            </button>
                                            <button *ngIf="!isAluno && !element?.isRecusado" type="button"
                                                (click)="recusar(element)" color="warn" mat-icon-button
                                                matTooltip="Recusar">
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                            <button type="button"
                                                (click)="download(element.id, element.arquivoString, element.extensao, element.tipoAnexo)"
                                                color="primary" mat-icon-button matTooltip="Download">
                                                <mat-icon>arrow_downward</mat-icon>
                                            </button>
                                            <button *ngIf="!isAluno" type="button" (click)="removeAnexo(element.id, i)"
                                                color="warn" mat-icon-button matTooltip="Excluir"
                                                [disabled]="isAluno && element?.isRecusado ? true : false">
                                                <mat-icon>delete</mat-icon>
                                            </button>
                                        </div>
                                    </td>
                                </ng-container>
                                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"
                                    (click)="selection.toggle(row)"
                                    [ngClass]="{ 'selected': selection.isSelected(row) }"></tr>
                            </table>
                        </div>
                    </div>
                </form>
                <mat-progress-bar *ngIf="sendingAnexo" mode="indeterminate" color="primary"></mat-progress-bar>
            </div>
        </mat-card-content>
        <mat-card-actions>
            <div class="flex align-center">
                <div class="flex-fill"></div>
                <!-- <button mat-button type="button" (click)="next()" color="primary">Continuar &nbsp;<mat-icon>send</mat-icon></button> -->
            </div>
        </mat-card-actions>
    </mat-card>
</div>
<input #fileUp class="file-upload" type="file" (change)="loadFile($event)">
<input #pendencia class="file-upload" type="file" (change)="uploadDeclaracao($event)">

<ng-template #errorTemplate>
    <app-server-error></app-server-error>
</ng-template>